<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-row class="fill-height" no-gutters>
          <v-col class="col-12">
            <v-row>
              <v-col class="col-12">
                <v-card-title>
                  <v-row>
                    <v-col class="col-12 col-md-5">
                      <h1 class="primary-color">Candidates</h1>
                    </v-col>
                    <v-spacer />
                    <v-col class="col-12 col-md-4">
                      <v-btn class="new-item-btn float-right" @click="openCreateCandidate()">
                        <v-icon size="20">mdi-account-plus</v-icon>
                        &nbsp;&nbsp;Register candidate
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>

                <v-alert
                  v-if="messageCreateCandidate"
                  outlined
                  :color="successfullCreateCandidate ? 'success' : 'error'"
                  :icon="successfullCreateCandidate ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageCreateCandidate }}
                </v-alert>
                <v-alert
                  v-if="messageUpdateCandidate"
                  outlined
                  :color="successfullUpdateCandidate ? 'success' : 'error'"
                  :icon="successfullUpdateCandidate ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageUpdateCandidate }}
                </v-alert>
                <v-alert
                  v-if="messageDeleteCandidate"
                  outlined
                  :color="successfullDeleteCandidate ? 'success' : 'error'"
                  :icon="successfullDeleteCandidate ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageDeleteCandidate }}
                </v-alert>
                <v-alert
                  v-if="messageCreateInterview"
                  outlined
                  :color="successfullCreateInterview ? 'success' : 'error'"
                  :icon="successfullCreateInterview ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageCreateInterview }}
                </v-alert>

                <v-alert
                  v-if="messageEditInterview"
                  outlined
                  :color="successfullEditInterview ? 'success' : 'error'"
                  :icon="successfullEditInterview ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageEditInterview }}
                </v-alert>
                <v-alert
                  v-if="messageDeleteInterview"
                  outlined
                  :color="successfullDeleteInterview ? 'success' : 'error'"
                  :icon="successfullDeleteInterview ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageDeleteInterview }}
                </v-alert>

                <v-alert
                  v-if="messageResendMail"
                  outlined
                  :color="successfullResendMail ? 'success' : 'error'"
                  :icon="successfullResendMail ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageResendMail }}
                </v-alert>

                <v-alert
                  v-if="messageUploadCV"
                  outlined
                  :color="successfullUploadCV ? 'success' : 'error'"
                  :icon="successfullUploadCV ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageUploadCV }}
                </v-alert>

                <v-data-table
                  :headers="headers"
                  :items="candidates"
                  item-key="id"
                  :loading="loading"
                  loading-text="Loading... Please, wait"
                  show-expand
                  single-expand
                  :expanded.sync="expanded"
                  :server-items-length="paginationCandidates.totalItems"
                  :items-per-page="paginationCandidates.itemsPerPage"
                  :page.sync="paginationCandidates.page"
                  item-class="text-wrap"
                  @update:page="handlePageChangeCandidates"
                >
                  <template #[`item.cvExtractionStatus`]="{ item }">
                    <v-chip :color="getColor(item.cvExtractionStatus)">
                      {{ item.cvExtractionStatus }}
                    </v-chip>
                  </template>
                  <template #[`item.createdAt`]="{ item }">
                    {{ item.createdAt | formatDate }}
                  </template>

                  <template #expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-4">
                      <v-card-title class="pt-0">
                        <h4 class="primary-color">Videointerviews</h4>
                      </v-card-title>
                      <v-data-table
                        v-if="item.interviews.length > 0"
                        :headers="headersInterviews"
                        :items="item.interviews"
                        item-key="id"
                        :loading="loading"
                        loading-text="Loading... Please, wait"
                        multi-sort
                        :server-items-length="paginationInterviews.totalItems"
                        :items-per-page="paginationInterviews.itemsPerPage"
                        :page.sync="paginationInterviews.page"
                        item-class="text-wrap"
                        @update:page="handlePageChangeInterviews"
                      >
                        <template #[`item.name`]="{ item }">
                          <v-card-text class="d-flex align-center">
                            {{ item.name | slice40Characters }}
                            <v-tooltip v-if="item.name.length >= 40" top>
                              <template #activator="{ on }">
                                <v-btn icon class="ml-2 more-info-btn" :ripple="false" v-on="on">
                                  <v-icon size="20" color="primary">mdi-information</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ item.name }}</span>
                            </v-tooltip>
                          </v-card-text>
                        </template>
                        <template #[`item.description`]="{ item }">
                          <v-card-text v-if="item.description !== null" class="d-flex align-center">
                            {{ item.description | slice20Characters }}
                            <v-tooltip v-if="item.description.length >= 20" top>
                              <template #activator="{ on }">
                                <v-btn icon class="ml-2 more-info-btn" :ripple="false" v-on="on">
                                  <v-icon size="20" color="primary">mdi-information</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ item.description }}</span>
                            </v-tooltip>
                          </v-card-text>

                          <v-card-text v-else class="d-flex align-center"> - </v-card-text>
                        </template>
                        <template #[`item.date`]="{ item }">
                          {{ item.date | formatDate }}
                        </template>
                        <template #[`item.position`]="{ item }">
                          {{ item.position.name }}
                        </template>
                        <template #[`item.isIaInterviewer`]="{ item }">
                          <v-card-text v-if="item.isIaInterviewer" class="d-flex align-end"
                            ><v-icon size="20" color="primary">mdi-robot</v-icon
                            >&nbsp;&nbsp;Avatar</v-card-text
                          >
                          <v-card-text v-else class="d-flex align-end"
                            ><v-icon size="20" color="primary">mdi-account</v-icon>&nbsp;&nbsp;Human
                            Interviewer</v-card-text
                          >
                        </template>
                        <template #[`item.interviewAnalysisType`]="{ item }">
                          <v-card-text class="d-flex align-center">
                            {{ getInterviewAnalysisTypeName(item) }}
                          </v-card-text>
                        </template>
                        <template #[`item.status`]="{ item }">
                          <v-chip :color="getColorInterviewStatus(item.status)">
                            {{ item.status }}
                          </v-chip>
                        </template>
                        <template #[`item.actions`]="{ item }">
                          <v-tooltip top>
                            <template #activator="{ on }">
                              <v-btn
                                icon
                                class="mr-2"
                                :disabled="item.status !== 'CREATED'"
                                v-on="on"
                                @click="openShowLinks(item)"
                              >
                                <v-icon size="20" color="primary">mdi-link-variant</v-icon>
                              </v-btn>
                            </template>
                            <span>Show links</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template #activator="{ on }">
                              <v-btn
                                icon
                                class="mr-2"
                                :disabled="item.status !== 'CREATED'"
                                v-on="on"
                                @click="openEditInterview(item)"
                              >
                                <v-icon size="20" color="primary">mdi-square-edit-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template #activator="{ on }">
                              <v-btn
                                icon
                                class="mr-2"
                                :disabled="!canReanalyzeInterview(item)"
                                v-on="on"
                                @click="openReanalyzeConfirmation(item)"
                              >
                                <v-icon size="20" color="warning">mdi-refresh</v-icon>
                              </v-btn>
                            </template>
                            <span>Re-analyze interview</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template #activator="{ on }">
                              <v-btn
                                v-if="['ANALYSED', 'ANALYSING', 'ERROR'].includes(item.status)"
                                icon
                                color="primary"
                                v-on="on"
                                @click="showAnalysis(item)"
                              >
                                <v-icon size="20">mdi-eye</v-icon>
                              </v-btn>
                            </template>
                            <span>Show analysis</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template #activator="{ on }">
                              <v-btn icon v-on="on" @click="openDeleteInterview(item)">
                                <v-icon size="20" color="error">mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            <span>Delete</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                      <v-alert
                        v-else-if="item.interviews.length === 0 && !messageInterviews"
                        outlined
                        type="info"
                        color="info"
                        class="mb-0"
                      >
                        The candidate has no scheduled videointerviews.
                      </v-alert>

                      <v-alert
                        v-if="messageInterviews"
                        class="mt-4"
                        outlined
                        :color="successfullInterviews ? 'success' : 'error'"
                        :icon="successfullInterviews ? 'mdi-check-circle' : 'mdi-alert'"
                        dismissible
                      >
                        {{ messageInterviews }}
                      </v-alert>
                    </td>
                  </template>

                  <template #[`item.actions`]="{ item }">
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon color="primary" v-on="on" @click="openUploadCV(item)">
                          <v-icon size="20">
                            {{
                              item.cvExtractionStatus === 'WITHOUT CV'
                                ? 'mdi-upload'
                                : 'mdi-upload-multiple'
                            }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{
                        item.cvExtractionStatus === 'WITHOUT CV' ? 'Upload CV' : 'Re-upload CV'
                      }}</span>
                    </v-tooltip>

                    <v-tooltip v-if="item.cvExtractionStatus === 'COMPLETED'" top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openCV(item)">
                          <v-icon size="20" color="primary">mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Show details</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon color="primary" v-on="on" @click="openCreateInterview(item)">
                          <v-icon size="20">mdi-video-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Create Videointerview</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openUpdateCandidate(item)">
                          <v-icon size="20" color="primary">mdi-square-edit-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Update Candidate</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openDeleteCandidate(item)">
                          <v-icon size="20" color="error">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete Candidate</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-alert
              v-if="messageCandidates"
              class="mt-4"
              outlined
              :color="successfullCandidates ? 'success' : 'error'"
              :icon="successfullCandidates ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageCandidates }}
            </v-alert>
            <v-alert
              v-if="messagePositions"
              class="mt-4"
              outlined
              :color="successfullPositions ? 'success' : 'error'"
              :icon="successfullPositions ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messagePositions }}
            </v-alert>
            <v-alert
              v-if="messageAnalysisTypes"
              class="mt-4"
              outlined
              :color="successfullAnalysisTypes ? 'success' : 'error'"
              :icon="successfullAnalysisTypes ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageAnalysisTypes }}
            </v-alert>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>

    <v-dialog v-model="createCandidateDialog" max-width="600" persistent>
      <v-card>
        <v-form ref="createCandidateForm" @submit.prevent="createCandidate">
          <v-card-title class="px-6">
            <h5 class="primary-color">Create candidate</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="candidate.username"
                    class="py-0 mb-6 no-border-radius"
                    label="Username *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="candidate.email"
                    class="py-0 mb-6 no-border-radius"
                    label="Email *"
                    :rules="rules"
                    dense
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="cancelCreateCandidate"> Cancel </v-btn>
            <v-btn
              v-if="!creatingCandidate"
              type="submit"
              class="ok-modal"
              :disabled="
                candidate.username.toString().trim() === '' ||
                candidate.email.toString().trim() === ''
              "
            >
              Create
            </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="updateCandidateDialog" max-width="600" persistent>
      <v-card>
        <v-form ref="updateCandidateForm" @submit.prevent="updateCandidate">
          <v-card-title class="px-6">
            <h5 class="primary-color">Update candidate</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="itemToEditCandidate.username"
                    class="py-0 mb-6 no-border-radius"
                    label="Username *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="itemToEditCandidate.email"
                    class="py-0 mb-6 no-border-radius"
                    label="Email *"
                    :rules="rules"
                    dense
                  />
                </v-col>
              </v-row>
              <v-alert
                v-if="messageUpdateCandidateInside"
                outlined
                :color="successfullUpdateCandidateInside ? 'success' : 'error'"
                :icon="successfullUpdateCandidateInside ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageUpdateCandidateInside }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="cancelUpdateCandidate"> Cancel </v-btn>
            <v-btn
              v-if="!updatingCandidate"
              type="submit"
              class="ok-modal"
              :disabled="itemToEditCandidate.username === '' || itemToEditCandidate.email === ''"
            >
              Update
            </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteCandidateDialog" max-width="550" min-height="550">
      <v-card>
        <v-card-title class="px-6">
          <h5 class="primary-color">Delete Candidate</h5>
        </v-card-title>
        <v-card-text class="pb-0">
          <p class="mb-0">
            Do you really want to delete the selected candidate? <br />
            If so, press Confirm.
          </p>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn text class="cancel-modal" @click="deleteCandidateDialog = false"> Cancel </v-btn>

          <template v-if="!deletingCandidate">
            <v-btn class="ok-modal" @click="deleteCandidate"> Confirm </v-btn>
          </template>
          <v-btn v-else class="ok-modal" disabled @click="deleteCandidate">
            <v-progress-circular indeterminate color="primary" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="uploadCVDialog" max-width="700" min-height="700">
      <v-card>
        <v-card-title class="px-6">
          <h5 class="primary-color">Upload CV</h5>
        </v-card-title>
        <v-card-text class="pb-0">
          <VueFileAgent
            ref="vueFileAgentUploadCV"
            v-model="fileRecordsCV"
            class="mt-4"
            :theme="'list'"
            :multiple="false"
            :deletable="true"
            :meta="true"
            :disabled="fileReceivedCV"
            :accept="'.pdf'"
            :max-size="'10MB'"
            :editable="false"
            :help-text="'Select PDF file to upload your CV (uncompressed)'"
            :error-text="{
              type: 'Wrong file extension. Please upload only .pdf files (uncompressed).',
              size: 'The maximum size per file is 10MB.',
            }"
            @select="filesSelectedCV($event)"
            @beforedelete="onBeforeDeleteCV($event)"
            @delete="fileDeletedCV($event)"
          />

          <v-alert
            v-if="messageUploadCVInside"
            outlined
            :color="successfullUploadCVInside ? 'success' : 'error'"
            :icon="successfullUploadCVInside ? 'mdi-check-circle' : 'mdi-alert'"
            dismissible
          >
            {{ messageUploadCVInside }}
          </v-alert>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn text class="cancel-modal" @click="uploadCVDialog = false"> Cancel </v-btn>

          <template v-if="!uploadingCV">
            <v-btn class="ok-modal" :disabled="uploadDisactiveCV" @click="uploadCV"> Upload </v-btn>
          </template>
          <v-btn v-else class="ok-modal" disabled @click="uploadCV">
            <v-progress-circular indeterminate color="primary" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="createInterviewDialog"
      max-width="880"
      persistent
      content-class="create-interview-dialog-content"
    >
      <v-card class="create-interview-card">
        <v-form ref="createInterviewForm" class="create-interview-form" @submit.prevent="createInterview">
          <v-card-title class="px-6">
            <h5 class="primary-color">Create video interview</h5>
          </v-card-title>
          <v-card-text class="mt-2 pb-0 px-6 create-interview-form__body">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="interview.name"
                    class="py-0 mb-6 no-border-radius"
                    label="Name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="interview.description"
                    :rules="rules"
                    class="py-0 mb-6 no-border-radius"
                    dense
                  >
                    <template #label>
                      <div>Description *</div>
                    </template>
                  </v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-select
                    ref="menuPositionsCreate"
                    v-model="interview.positionId"
                    class="py-0 mb-6 no-border-radius"
                    label="Position *"
                    :items="positionsCreate"
                    item-text="name"
                    item-value="id"
                    :rules="rules"
                    :loading="loadingPositionsCreate"
                    attach
                  />
                </v-col>
                <v-col cols="12">
                  <v-select
                    ref="menuInterviewAnalysisTypesCreate"
                    v-model="interview.analysisTypeId"
                    class="py-0 mb-6 no-border-radius"
                    label="Analysis Type *"
                    :items="analysisTypesCreate"
                    :item-text="configLabel"
                    item-value="id"
                    :rules="rules"
                    :loading="loadingInterviewAnalysisTypesCreate"
                    attach
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="interview.urlRedirect"
                    class="py-0 mb-6 no-border-radius"
                    label="URL to redirect *"
                    :rules="urlRules"
                    dense
                  />
                </v-col>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <v-menu
                        v-model="menuDate"
                        class="no-limit-height"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template #activator="{ on }">
                          <v-text-field
                            v-model="interview.day"
                            :label="
                              interview.isIaInterviewer
                                ? 'Maximum date of implementation *'
                                : 'Date *'
                            "
                            readonly
                            :rules="rules"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker v-model="interview.day" locale="es-es" :min="now" />
                      </v-menu>
                    </v-col>
                    <v-col cols="12">
                      <v-menu
                        v-model="menuTime"
                        class="no-limit-height"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template #activator="{ on }">
                          <v-text-field
                            v-model="interview.hour"
                            :label="
                              interview.isIaInterviewer
                                ? 'Maximum hour of implementation *'
                                : 'Hour *'
                            "
                            readonly
                            :rules="rules"
                            v-on="on"
                          />
                        </template>
                        <v-time-picker v-model="interview.hour" format="24hr" elevation="15" />
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-alert
                v-if="messageDialog"
                class="mt-4"
                outlined
                :color="successfullDialog ? 'success' : 'error'"
                :icon="successfullDialog ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageDialog }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="cancelCreateInterview"> Cancel </v-btn>
            <v-btn v-if="!creating" type="submit" class="ok-modal"> Create </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editInterviewDialog" max-width="800" persistent>
      <v-card>
        <v-form ref="editInterviewForm" @submit.prevent="editInterview">
          <v-card-title class="px-6">
            <h5 class="primary-color">Edit video interview</h5>
          </v-card-title>
          <v-card-subtitle class="px-6 pt-0 pb-2">
            Update scheduling, analysis type, or redirect URL. Required fields are marked with *.
          </v-card-subtitle>
          <v-card-text class="mt-2 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="itemToEditInterview.name"
                    class="py-0 mb-6 no-border-radius"
                    label="Name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="itemToEditInterview.description"
                    class="py-0 mb-6 no-border-radius"
                    :rules="rules"
                    dense
                  >
                    <template #label>
                      <div>Description *</div>
                    </template>
                  </v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="itemToEditInterview.positionId"
                    class="py-0 mb-6 no-border-radius"
                    :items="positionsEdit"
                    item-text="name"
                    item-value="id"
                    label="Position *"
                    :rules="rules"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="itemToEditInterview.urlRedirect"
                    class="py-0 mb-6 no-border-radius"
                    label="URL to redirect *"
                    :rules="urlRules"
                    dense
                  />
                </v-col>
                <v-col cols="6">
                  <v-radio-group v-model="itemToEditInterview.isIaInterviewer">
                    <template #label>Interviewer type *</template>
                    <v-radio
                      v-for="(option, index) in optionsInterviewer"
                      :key="index"
                      :label="option.label"
                      :value="option.value"
                    />
                  </v-radio-group>
                </v-col>
                <v-col cols="6">
                  <v-row>
                    <v-col cols="12">
                      <v-menu
                        v-model="menuDateEdit"
                        class="no-limit-height"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template #activator="{ on }">
                          <v-text-field
                            v-model="itemToEditInterview.day"
                            :label="
                              itemToEditInterview.isIaInterviewer
                                ? 'Maximum date of implementation *'
                                : 'Date *'
                            "
                            readonly
                            :rules="rules"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="itemToEditInterview.day"
                          locale="es-es"
                          :min="now"
                        />
                      </v-menu>
                    </v-col>
                    <v-col cols="12">
                      <v-menu
                        v-model="menuTimeEdit"
                        class="no-limit-height"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template #activator="{ on }">
                          <v-text-field
                            v-model="itemToEditInterview.hour"
                            :label="
                              itemToEditInterview.isIaInterviewer
                                ? 'Maximum hour of implementation *'
                                : 'Hour *'
                            "
                            readonly
                            :rules="rules"
                            v-on="on"
                          />
                        </template>
                        <v-time-picker
                          v-model="itemToEditInterview.hour"
                          format="24hr"
                          elevation="15"
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-alert
                v-if="messageDialogEditInterview"
                outlined
                :color="successfullDialog ? 'success' : 'error'"
                :icon="successfullDialog ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageDialogEditInterview }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="cancelEditInterview"> Cancel </v-btn>
            <v-btn v-if="!updating" type="submit" class="ok-modal"> Save changes </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteInterviewDialog" max-width="550" min-height="550">
      <v-card>
        <v-card-title class="px-6">
          <h5 class="primary-color">Delete videointerview</h5>
        </v-card-title>
        <v-card-text class="pb-0">
          <p class="mb-8">
            Do you really want to delete the selected video interview?<br />If yes, press yes, press
            Confirm.
          </p>
          <v-textarea v-model="reason" :rules="rules" class="py-0 mb-6 no-border-radius" dense>
            <template #label>
              <div>Reason *</div>
            </template>
          </v-textarea>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn text class="cancel-modal" @click="deleteInterviewDialog = false"> Cancel </v-btn>

          <template v-if="!deletingInterview">
            <v-btn v-if="reason !== ''" class="ok-modal" @click="deleteInterview"> Confirm </v-btn>
            <v-btn v-else class="ok-modal" disabled @click="deleteInterview"> Confirm </v-btn>
          </template>
          <v-btn v-else class="ok-modal" disabled @click="deleteInterview">
            <v-progress-circular indeterminate color="primary" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <LaunchAnalysisDialog
      v-model="launchAnalysisDialog"
      source-type="interview"
      :targets="launchAnalysisTargets"
      :analysis-types="analysisTypesEdit"
      :loading-analysis-types="loadingReanalyzeAnalysisTypes"
      :socket-id="$socketId || ''"
      @launched="onAnalysisLaunched"
    />

    <v-dialog v-model="showLinksDialog" width="900">
      <v-card>
        <v-card-title class="px-6">
          <h5 class="primary-color">Links</h5>
        </v-card-title>
        <v-card-text class="pb-0 mt-4">
          <v-row v-if="!itemToShowLinks.isIaInterviewer">
            <v-col cols="2">
              <h6 class="details-subtitles primary-color">Interviewer:</h6>
            </v-col>
            <v-col cols="9">
              <p>{{ itemToShowLinks.urlInterviewer || '' }}</p>
            </v-col>
            <v-col cols="1">
              <v-icon color="primary" @click="copyToClipboard(itemToShowLinks.urlInterviewer)"
                >mdi-content-copy</v-icon
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <h6 class="details-subtitles primary-color">Candidate:</h6>
            </v-col>
            <v-col cols="9">
              <p>{{ itemToShowLinks.urlCandidate || '' }}</p>
            </v-col>
            <v-col cols="1">
              <v-icon color="primary" @click="copyToClipboard(itemToShowLinks.urlCandidate)"
                >mdi-content-copy</v-icon
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn text class="ok-modal" @click="showLinksDialog = false"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import LaunchAnalysisDialog from '@/components/analysis/runs/LaunchAnalysisDialog.vue';
import CandidatesDataService from '@/services/CandidatesDataService';
import InterviewsDataService from '@/services/InterviewsDataService';
import PositionsDataService from '@/services/PositionsDataService';
import SocketioService from '@/services/socketioService';
import VideosDataService from '@/services/VideosDataService';
import { analysisConfigLabel, mergeConfigs } from '@/utils/activeAnalysisConfig';
import utils from '@/utils/utils';

export default {
  name: 'CandidatesList',
  components: { LaunchAnalysisDialog },
  data() {
    return {
      candidates: [],
      successfullCandidates: false,
      messageCandidates: '',
      successfullPositions: false,
      messagePositions: '',
      successfullAnalysisTypes: false,
      messageAnalysisTypes: '',
      successfullInterviews: true,
      messageInterviews: '',
      loading: false,
      successfullCreateCandidate: false,
      messageCreateCandidate: '',
      successfullUpdateCandidate: false,
      messageUpdateCandidate: '',
      successfullDeleteCandidate: false,
      messageDeleteCandidate: '',
      headers: [
        { text: 'Username', value: 'username', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        {
          text: 'CV analysis status',
          value: 'cvExtractionStatus',
          sortable: false,
        },
        { text: 'Created at', value: 'createdAt', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      expanded: [],
      paginationCandidates: {
        page: 1,
        itemsPerPage: 10,
        totalPages: 1,
        totalItems: 0,
      },
      headersInterviews: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Date and hour', value: 'date', sortable: false },
        { text: 'Position', value: 'position', sortable: false },
        { text: 'Interviewer', value: 'isIaInterviewer', sortable: false },
        { text: 'Analysis type', value: 'interviewAnalysisType', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      paginationInterviews: {
        page: 1,
        itemsPerPage: 10,
        totalPages: 1,
        totalItems: 0,
      },
      candidateId: null,
      candidateIndex: null,
      deleteCandidateDialog: false,
      deletingCandidate: false,
      itemToDelete: {},
      itemToCreateInterview: null,
      createInterviewDialog: false,
      rules: [(v) => !!v || 'Required field'],
      urlRules: [
        (v) => !!v || 'Required field',
        (v) =>
          /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/.test(v) ||
          'Invalid URL format',
      ],
      positionsCreate: [],
      positionsEdit: [],
      analysisTypesCreate: [],
      analysisTypesEdit: [],
      optionsInterviewer: [
        { label: 'Interviewer', value: false },
        { label: 'Avatar', value: true },
      ],
      menuDate: false,
      menuTime: false,
      interview: {
        name: '',
        description: '',
        positionId: null,
        analysisTypeId: null,
        urlRedirect: '',
        isIaInterviewer: true,
        day: null,
        hour: null,
      },
      messageDialog: '',
      successfullDialog: false,
      candidate: {
        username: '',
        email: '',
      },
      now: null,
      nowTZ: null,
      nowSpaceSeparator: null,
      creating: false,
      creatingCandidate: false,
      createCandidateDialog: false,
      messageCreateInterview: '',
      successfullCreateInterview: false,
      updatingCandidate: false,
      updateCandidateDialog: false,
      itemToEditCandidate: {},
      messageUpdateCandidate: '',
      successfullUpdateCandidate: false,
      messageUpdateCandidateInside: '',
      successfullUpdateCandidateInside: false,

      itemToDeleteInterview: null,
      deleteInterviewDialog: false,
      reason: '',
      deletingInterview: false,
      messageDeleteInterview: '',
      successfullDeleteInterview: false,
      launchAnalysisDialog: false,
      launchAnalysisTargets: [],
      loadingReanalyzeAnalysisTypes: false,

      itemToEditInterview: {},
      editInterviewDialog: false,
      updating: false,
      menuDateEdit: false,
      menuTimeEdit: false,
      messageDialogEditInterview: '',
      successfullEditInterview: false,
      messageEditInterview: '',

      successfullResendMail: false,
      messageResendMail: '',

      itemToShowLinks: {},
      showLinksDialog: false,

      pagePositionsCreate: 1,
      totalItemsPositionsCreate: 0,
      itemsPerPagePositionsCreate: 10,
      loadingPositionsCreate: false,
      isMenuOpenPositionsCreate: false,

      pageInterviewAnalysisTypesCreate: 1,
      totalItemsInterviewAnalysisTypesCreate: 0,
      itemsPerPageInterviewAnalysisTypesCreate: 10,
      loadingInterviewAnalysisTypesCreate: false,
      isMenuOpenInterviewAnalysisTypesCreate: false,
      utils: utils,

      uploadCVDialog: false,
      fileReceivedCV: false,
      fileRecordsCV: [],
      fileRecordsForUploadCV: [],
      uploadingCV: false,
      uploadDisactiveCV: true,
      itemToUploadCV: {},
      successfullUploadCV: false,
      messageUploadCV: '',
      successfullUploadCVInside: false,
      messageUploadCVInside: '',
    };
  },
  computed: {},
  watch: {
    expanded: {
      handler() {
        this.successfullInterviews = true;

        this.paginationInterviews = {
          page: 1,
          itemsPerPage: 10,
          totalPages: 1,
        };
        this.expanded.forEach((item) => {
          this.candidateIndex = this.candidates.findIndex((candidate) => candidate.id === item.id);

          this.candidates[this.candidateIndex].interviews = [];

          if (this.candidates[this.candidateIndex].interviews.length === 0) {
            this.candidateId = this.candidates[this.candidateIndex].id;
            this.getAllInterviewsFromCandidate(this.candidateId, 1);
          }
        });
      },
      deep: true,
    },
    createInterviewDialog(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.observeMenuPositionsCreate();
          this.observeMenuInterviewAnalysisTypesCreate();
        });
        this.preselectActiveAnalysisType();
      }
    },
  },
  async mounted() {
    this.getDateTimeNow();
    await this.getAllPositionsEdit();
    await this.getAllInterviewAnalysisTypesEdit();
    await this.getAllCandidates(1);

    // Listen for CV analysis completion/error to auto-refresh table
    SocketioService.emisor.$on('notificationsActiveSended', (data) => {
      console.log('[CV Analysis] Notification received:', data);

      // Only refresh if it's a CV-related notification
      if (data.type === 'CV') {
        console.log('[CV Analysis] Refreshing candidates table...');
        // Refresh the table to show updated status
        this.getAllCandidates(this.paginationCandidates.page);
      }
    });
  },
  methods: {
    deleteUploadedFileCV(fileRecord) {
      this.$refs.vueFileAgentCV.deleteUpload(this.uploadUrlCV, this.uploadHeadersCV, fileRecord);
    },
    filesSelectedCV(fileRecordsNewlySelected) {
      const validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
      if (validFileRecords.length > 0) {
        this.uploadDisactiveCV = false;
        this.fileRecordsForUploadCV = this.fileRecordsForUploadCV.concat(validFileRecords);
      } else this.uploadDisactiveCV = true;
    },
    onBeforeDeleteCV(fileRecord) {
      const i = this.fileRecordsForUploadCV.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUploadCV.splice(i, 1);
        const k = this.fileRecordsCV.indexOf(fileRecord);
        if (k !== -1) this.fileRecordsCV.splice(k, 1);
      } else this.$refs.vueFileAgentCV.deleteFileRecordCV(fileRecord);

      this.uploadDisactiveCV = this.fileRecordsForUploadCV.length <= 0;
      if (this.fileRecordsForUploadCV.length <= 0) this.message = '';
    },
    fileDeletedCV(fileRecord) {
      const i = this.fileRecordsForUploadCV.indexOf(fileRecord);

      if (i !== -1) this.fileRecordsForUploadCV.splice(i, 1);
      else this.deleteUploadedFileCV(fileRecord);

      this.uploadDisactiveCV = this.fileRecordsForUploadCV.length <= 0;
      if (this.fileRecordsForUploadCV.length <= 0) this.message = '';
    },

    getDateTimeNow() {
      const tmpDate = new Date();

      tmpDate.setHours(tmpDate.getHours() - 1);

      const year = tmpDate.getFullYear();
      const month = String(tmpDate.getMonth() + 1).padStart(2, '0');
      const day = String(tmpDate.getDate()).padStart(2, '0');
      const hours = String(tmpDate.getHours()).padStart(2, '0');
      const minutes = String(tmpDate.getMinutes()).padStart(2, '0');

      this.now = `${year}-${month}-${day}T${hours}:${minutes}`;
      this.nowSpaceSeparator = `${year}-${month}-${day} ${hours}:${minutes}`;
      this.nowTZ = `${year}-${month}-${day}T${hours}:${minutes}:00.000Z`;
    },
    getAllCandidates(page) {
      this.loading = true;

      CandidatesDataService.findAll(page, this.paginationCandidates.itemsPerPage).then(
        (response) => {
          if (response.status == 200) {
            this.candidates = response.data.data;
            this.candidates.forEach((candidate) => {
              candidate.interviews = [];
              if (candidate.cvExtractionStatus === '') candidate.cvExtractionStatus = 'WITHOUT CV';
            });
            if (this.candidates.length !== 0) {
              this.paginationCandidates.page = page;
              this.paginationCandidates.totalPages = response.data.links.totalPages || 1;

              this.paginationCandidates.totalItems =
                response.data.links.totalItems ||
                this.paginationCandidates.totalPages * this.paginationCandidates.itemsPerPage;
            }
          } else {
            this.successfullCandidates = false;
            this.messageCandidates =
              'An error has occurred retrieving the list of candidates. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullCandidates = false;
          this.messageCandidates =
            'An error has occurred retrieving the list of candidates. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    handlePageChangeCandidates(newPage) {
      this.paginationCandidates.page = newPage;
      this.getAllCandidates(newPage);
    },
    getAllInterviewsFromCandidate(id, page) {
      CandidatesDataService.findAllInterviewsFromCandidate(
        id,
        page,
        this.paginationInterviews.itemsPerPage
      ).then(
        (response) => {
          if (response.status == 200) {
            this.candidates[this.candidateIndex].interviews = response.data.data;

            this.candidates.forEach((candidate) => {
              candidate.interviews.forEach((interview) => {
                interview.candidateId = candidate.id;
              });
            });

            if (this.candidates[this.candidateIndex].interviews.length > 0) {
              this.paginationInterviews.page = page;
              this.paginationInterviews.totalPages = response.data.links.totalPages || 1;

              this.paginationInterviews.totalItems =
                response.data.links.totalItems ||
                this.paginationInterviews.totalPages * this.paginationInterviews.itemsPerPage;
            }

            this.$forceUpdate();
          } else {
            this.successfullInterviews = false;
            this.messageInterviews =
              'An error has occurred retrieving the list of interviews. Please, try again later.';
          }
        },
        (error) => {
          this.successfullInterviews = false;
          this.messageInterviews =
            'An error has occurred retrieving the list of interviews. Please, try again later.';

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }
          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );
        }
      );
    },
    handlePageChangeInterviews(newPage) {
      this.paginationInterviews.page = newPage;
      this.getAllInterviewsFromCandidate(this.candidateId, newPage);
    },
    observeMenuPositionsCreate() {
      const menu = this.$refs.menuPositionsCreate;
      if (!menu) return;

      const observer = new MutationObserver(() => {
        this.$nextTick(() => {
          const dropdown = menu.$el.querySelector('.v-menu__content');

          if (dropdown && !this.isMenuOpenPositionsCreate) {
            this.onOpenPositionsCreate(true);
            this.isMenuOpenPositionsCreate = true;
            dropdown.addEventListener('scroll', this.onScrollPositionsCreate);
          } else if (!dropdown && this.isMenuOpenPositionsCreate) {
            this.onOpenPositionsCreate(false);
            this.isMenuOpenPositionsCreate = false;
          }
        });
      });

      observer.observe(menu.$el, { childList: true, subtree: true });
    },
    getAllPositionsCreate() {
      if (this.loadingPositionsCreate) return;
      this.loadingPositionsCreate = true;

      PositionsDataService.findAll(this.pagePositionsCreate, this.itemsPerPagePositionsCreate).then(
        (response) => {
          if (response.status == 200) {
            if (response.data.data.length === 0) {
              this.loadingPositionsCreate = false;
              return;
            }

            this.positionsCreate = [...this.positionsCreate, ...response.data.data];
            this.totalItemsPositionsCreate = response.data.links.totalItems;
            this.pagePositionsCreate++;
          } else {
            this.successfullPositions = false;
            this.messagePositions =
              'An error has occurred retrieving the list of positions. Please, try again later.';
          }

          this.loadingPositionsCreate = false;
        },
        (error) => {
          this.successfullPositions = false;
          this.messagePositions =
            'An error has occurred retrieving the list of positions. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loadingPositionsCreate = false;
        }
      );
    },
    onOpenPositionsCreate(isOpen) {
      if (isOpen && this.positionsCreate.length === 0) {
        this.getAllPositionsCreate();
      }
    },
    onScrollPositionsCreate(event) {
      const dropdown = event.target;
      if (
        dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 &&
        !this.loadingPositionsCreate
      ) {
        this.getAllPositionsCreate();
      }
    },
    getAllPositionsEdit() {
      this.loading = true;

      PositionsDataService.findAll(-1, 0).then(
        (response) => {
          if (response.status == 200) this.positionsEdit = response.data.data;
          else {
            this.successfullPositions = false;
            this.messagePositions =
              'An error has occurred retrieving the list of positions. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullPositions = false;
          this.messagePositions =
            'An error has occurred retrieving the list of positions. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    observeMenuInterviewAnalysisTypesCreate() {
      const menu = this.$refs.menuInterviewAnalysisTypesCreate;
      if (!menu) return;

      const observer = new MutationObserver(() => {
        this.$nextTick(() => {
          const dropdown = menu.$el.querySelector('.v-menu__content');

          if (dropdown && !this.isMenuOpenInterviewAnalysisTypesCreate) {
            this.onOpenInterviewAnalysisTypesCreate(true);
            this.isMenuOpenInterviewAnalysisTypesCreate = true;
            dropdown.addEventListener('scroll', this.onScrollInterviewAnalysisTypesCreate);
          } else if (!dropdown && this.isMenuOpenInterviewAnalysisTypesCreate) {
            this.onOpenInterviewAnalysisTypesCreate(false);
            this.isMenuOpenInterviewAnalysisTypesCreate = false;
          }
        });
      });

      observer.observe(menu.$el, { childList: true, subtree: true });
    },
    getAllInterviewAnalysisTypesCreate() {
      if (this.loadingInterviewAnalysisTypesCreate) return;
      this.loadingInterviewAnalysisTypesCreate = true;

      InterviewsDataService.findAllInterviewAnalysisTypes(
        this.pageInterviewAnalysisTypesCreate,
        this.itemsPerPageInterviewAnalysisTypesCreate
      ).then(
        (response) => {
          if (response.status == 200) {
            if (response.data.data.length === 0) {
              this.loadingInterviewAnalysisTypesCreate = false;
              return;
            }

            this.analysisTypesCreate = mergeConfigs(this.analysisTypesCreate, response.data.data);
            this.totalItemsInterviewAnalysisTypesCreate = response.data.links.totalItems;
            this.pageInterviewAnalysisTypesCreate++;
          } else {
            this.successfullAnalysisTypes = false;
            this.messageAnalysisTypes =
              'An error has occurred retrieving the list of analysis types. Please, try again later.';
          }

          this.loadingInterviewAnalysisTypesCreate = false;
        },
        (error) => {
          this.successfullAnalysisTypes = false;
          this.messageAnalysisTypes =
            'An error has occurred retrieving the list of analysis types. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loadingInterviewAnalysisTypesCreate = false;
        }
      );
    },
    onOpenInterviewAnalysisTypesCreate(isOpen) {
      // By page and not by length: the preselected active configuration may already be the one
      // option held before any page was read.
      if (isOpen && this.pageInterviewAnalysisTypesCreate === 1) {
        this.getAllInterviewAnalysisTypesCreate();
      }
    },
    configLabel(config) {
      return analysisConfigLabel(config);
    },
    /**
     * A new interview starts on the platform's active configuration: the one the back-office
     * stars, and the one Beon analyses with. It stays a choice — the select still offers the rest.
     *
     * Only while nothing is chosen, so an answer arriving after the user picked one never undoes
     * the pick. With none active (404) the select stays empty and required, as it always was.
     */
    preselectActiveAnalysisType() {
      InterviewsDataService.findActiveInterviewAnalysisType().then(
        (response) => {
          const active = response.data?.data;
          if (!active || this.interview.analysisTypeId) return;

          this.analysisTypesCreate = mergeConfigs([active], this.analysisTypesCreate);
          this.interview.analysisTypeId = active.id;
        },
        (error) => {
          if (error.response?.status === 404) return;

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );
        }
      );
    },
    onScrollInterviewAnalysisTypesCreate(event) {
      const dropdown = event.target;
      if (
        dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 &&
        !this.loadingInterviewAnalysisTypesCreate
      ) {
        this.getAllInterviewAnalysisTypesCreate();
      }
    },
    getAllInterviewAnalysisTypesEdit() {
      this.loading = true;

      return InterviewsDataService.findAllInterviewAnalysisTypes(-1, 0).then(
        (response) => {
          if (response.status == 200) this.analysisTypesEdit = response.data.data;
          else {
            this.successfullAnalysisTypes = false;
            this.messageAnalysisTypes =
              'An error has occurred retrieving the list of analysis types. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullAnalysisTypes = false;
          this.messageAnalysisTypes =
            'An error has occurred retrieving the list of analysis types. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    openCreateCandidate() {
      this.candidate = {
        username: '',
        email: '',
      };
      this.createCandidateDialog = true;
    },
    cancelCreateCandidate() {
      this.createCandidateDialog = false;
      this.candidate = {
        username: '',
        email: '',
      };
    },
    createCandidate() {
      this.creatingCandidate = true;
      CandidatesDataService.create(this.candidate).then(
        (response) => {
          if (response.status == 202) {
            this.successfullCreateCandidate = true;
            this.messageCreateCandidate = 'Candidate successfully created.';
            this.getAllCandidates(1);
          } else {
            this.successfullCreateCandidate = false;
            this.messageCreateCandidate =
              'An error has occurred creating the candidate. Please, try again later.';
          }

          this.createCandidateDialog = false;
          this.creatingCandidate = false;
        },
        (error) => {
          this.successfullCreateCandidate = false;
          this.messageCreateCandidate =
            'An error has occurred creating the candidate. Please, try again later.';

          this.createCandidateDialog = false;
          this.creatingCandidate = false;

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }
          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );
        }
      );
    },
    openUpdateCandidate(candidate) {
      this.updateCandidateDialog = true;
      this.itemToEditCandidate = { ...candidate };
    },
    cancelUpdateCandidate() {
      this.updateCandidateDialog = false;
    },
    updateCandidate() {
      this.updatingCandidate = true;
      CandidatesDataService.update(this.itemToEditCandidate).then(
        (response) => {
          if (response.status == 204) {
            setTimeout(() => {
              this.getAllCandidates(1);
              this.successfullUpdateCandidate = true;
              this.messageUpdateCandidate = 'Candidate successfully updated.';
              this.updateCandidateDialog = false;

              this.$forceUpdate();
            }, 500);
          } else {
            this.successfullUpdateCandidateInside = false;
            setTimeout(() => {
              this.messageUpdateCandidateInside =
                'An error has occurred updating the candidate. Please, try again later.';
            }, 10);

            this.$forceUpdate();
          }

          this.updatingCandidate = false;
        },
        (error) => {
          this.successfullUpdateCandidateInside = false;
          console.log('error: ', error);
          setTimeout(() => {
            this.messageUpdateCandidateInside =
              'An error has occurred updating the candidate. Please, check if the username and email already exists and try again.';
          }, 10);

          this.updatingCandidate = false;

          this.$forceUpdate();

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }
          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );
        }
      );
    },
    // openUploadCVs() {
    //   this.$router.push("/upload-cv");
    // },
    openDeleteCandidate(candidate) {
      this.itemToDelete = { ...candidate };
      this.deleteCandidateDialog = true;
    },
    deleteCandidate() {
      if (this.itemToDelete.id !== undefined) {
        this.deletingCandidate = true;

        CandidatesDataService.delete(this.itemToDelete.id).then(
          (response) => {
            if (response.status == 204) {
              this.getAllCandidates(1);
              this.expanded = [];
              this.messageDeleteCandidate = '';
              this.successfullDeleteCandidate = true;

              setTimeout(() => {
                this.messageDeleteCandidate = 'Candidate successfully deleted.';
              }, 10);
              this.$forceUpdate();
            } else {
              this.messageDeleteCandidate = '';
              this.successfullDeleteCandidate = false;

              setTimeout(() => {
                this.messageDeleteCandidate =
                  'An error has occurred deleting the candidate. Please, try again later.';
              }, 10);
            }

            this.deleteCandidateDialog = false;
            this.deletingCandidate = false;
            this.itemToDelete = {};
          },
          (error) => {
            this.messageDeleteCandidate = '';
            this.successfullDeleteCandidate = false;

            setTimeout(() => {
              this.messageDeleteCandidate =
                'An error has occurred deleting the candidate. Please, try again later.';
            }, 10);

            this.deleteCandidateDialog = false;
            this.itemToDelete = {};

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            }

            this.deletingCandidate = false;
          }
        );
      } else {
        this.messageDeleteCandidate = '';
        this.successfullDeleteCandidate = false;

        setTimeout(() => {
          this.messageDeleteCandidate =
            'An error has occurred deleting the candidate. Please, try again later.';
        }, 10);

        this.deleteCandidateDialog = false;
        this.itemToDelete = {};
      }
    },
    getColor(item) {
      if (item === 'PENDING') return 'warning';
      else if (item === 'PROCESSING') return 'accent';
      else if (item === 'COMPLETED') return 'success';
      else if (item === 'WITHOUT CV') return 'info';
      else return 'error';
    },
    getColorInterviewStatus(item) {
      if (item === 'CREATED') return 'info';
      else if (item === 'ONGOING') return 'accent';
      else if (item === 'ANALYSING') return 'warning';
      else if (item === 'ANALYSED') return 'success';
      else return 'error';
    },
    openCreateInterview(candidate) {
      if (this.$refs.createInterviewForm !== undefined) this.$refs.createInterviewForm.reset();
      this.createInterviewDialog = true;
      if (candidate !== undefined) this.itemToCreateInterview = { ...candidate };
      else this.itemToCreateInterview = undefined;
    },
    cancelCreateInterview() {
      this.createInterviewDialog = false;
    },
    createInterview() {
      this.successfullDialog = true;
      this.messageDialog = '';

      if (this.$refs.createInterviewForm.validate()) {
        const dateTime = this.interview.day + 'T' + this.interview.hour;
        if (this.checkValidDateTime(dateTime)) {
          this.interview.date = this.getDateTimeTZFormat(this.interview.day, this.interview.hour);

          if (this.interview.urlRedirect && !this.interview.urlRedirect.match(/^https?:\/\//)) {
            this.interview.urlRedirect = 'https://' + this.interview.urlRedirect;
          }

          this.creating = true;

          if (this.itemToCreateInterview !== undefined) {
            this.interview.candidateId = this.itemToCreateInterview.id;

            const formData = new FormData();
            for (const key in this.interview) {
              if (this.interview.hasOwnProperty(key)) {
                formData.append(key, this.interview[key]);
              }
            }

            InterviewsDataService.create(formData).then(
              (response) => {
                if (response.status == 201) {
                  this.getAllCandidates(1);
                  this.expanded = [];
                  this.successfullCreateInterview = true;
                  this.messageCreateInterview = 'Video interview created successfully.';
                  this.createInterviewDialog = false;
                  this.$forceUpdate();
                } else {
                  this.successfullCreateInterview = false;
                  this.messageCreateInterview =
                    'An error has occurred creating the videointerview. Please, try again later.';
                  this.createInterviewDialog = false;
                }
                this.creating = false;
              },
              (error) => {
                this.successfullCreateInterview = false;
                this.messageCreateInterview =
                  'An error has occurred creating the videointerview. Please, try again later.';
                this.createInterviewDialog = false;
                console.error(
                  (error.response && error.response.data) || error.message || error.toString()
                );

                if (error.response.status === 401 || error.response.status === 403) {
                  localStorage.removeItem('user');
                  this.$router.push('/');
                }

                this.creating = false;
              }
            );
          } else {
            this.interview.candidateId = undefined;

            const formData = new FormData();
            formData.append('name', this.interview.name);
            if (this.interview.description) {
              formData.append('description', this.interview.description);
            }
            formData.append('positionId', this.interview.positionId);
            formData.append('analysisTypeId', this.interview.analysisTypeId);
            formData.append('isIaInterviewer', this.interview.isIaInterviewer);
            formData.append('urlRedirect', this.interview.urlRedirect);
            formData.append('date', this.interview.date);

            InterviewsDataService.createNoCVInterview(formData).then(
              (response) => {
                if (response.status == 201) {
                  this.getAllCandidates(1);
                  this.expanded = [];
                  this.successfullCreateInterview = true;
                  this.messageCreateInterview = 'User without CV created successfully.';
                  this.createInterviewDialog = false;
                  this.$forceUpdate();
                } else {
                  this.successfullCreateInterview = false;
                  this.messageCreateInterview =
                    'An error has occurred creating the user without CV. Please, try again later.';
                  this.createInterviewDialog = false;
                }
                this.creating = false;
              },
              (error) => {
                this.successfullCreateInterview = false;
                this.messageCreateInterview =
                  'An error has occurred creating the user without CV. Please, try again later.';
                this.createInterviewDialog = false;
                console.error(
                  (error.response && error.response.data) || error.message || error.toString()
                );

                if (error.response.status === 401 || error.response.status === 403) {
                  localStorage.removeItem('user');
                  this.$router.push('/');
                }

                this.creating = false;
              }
            );
          }
        } else {
          this.successfullDialog = false;
          this.messageDialog =
            'The date and time specified must be after the current date and time.';
        }
      }
    },
    openDeleteInterview(interview) {
      this.deleteInterviewDialog = true;
      this.itemToDeleteInterview = { ...interview };
    },
    deleteInterview() {
      if (this.itemToDeleteInterview.id !== undefined) {
        this.deletingInterview = true;
        InterviewsDataService.delete(
          this.itemToDeleteInterview.id,
          this.itemToDeleteInterview.candidateId,
          this.itemToDeleteInterview.position.id,
          this.reason
        ).then(
          (response) => {
            if (response.status == 200) {
              this.getAllCandidates(1);
              this.expanded = [];
              this.reason = '';
              this.successfullDeleteInterview = true;
              this.messageDeleteInterview = 'Videointerview successfully deleted.';
              this.$forceUpdate();
            } else {
              this.reason = '';
              this.successfullDeleteInterview = false;
              this.messageDeleteInterview =
                'An error has occurred deleting the videointerview. Please, try again later.';
            }

            this.deleteInterviewDialog = false;
            this.deletingInterview = false;
          },
          (error) => {
            this.reason = '';
            this.successfullDeleteInterview = false;
            this.messageDeleteInterview =
              'An error has occurred deleting the videointerview. Please, try again later.';
            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            }

            this.deleteInterviewDialog = false;
            this.deletingInterview = false;
          }
        );
      } else {
        this.successfullDeleteInterview = false;
        this.messageDeleteInterview =
          'An error has occurred deleting the videointerview. Please, try again later.';
        this.deleteInterviewDialog = false;
      }
    },
    openEditInterview(interview) {
      this.editInterviewDialog = true;
      this.itemToEditInterview = { ...interview };
      this.itemToEditInterview.positionId = this.itemToEditInterview.position.id;
      const tmpDayHour = this.getDayHourFromTZ(this.itemToEditInterview.date);
      this.itemToEditInterview.day = tmpDayHour[0];
      this.itemToEditInterview.hour = tmpDayHour[1];
    },
    editInterview() {
      this.successfullDialog = true;
      this.messageDialogEditInterview = '';
      if (this.$refs.editInterviewForm.validate()) {
        const dateTime = this.itemToEditInterview.day + 'T' + this.itemToEditInterview.hour;
        if (this.checkValidDateTime(dateTime)) {
          this.itemToEditInterview.date = this.getDateTimeTZFormat(
            this.itemToEditInterview.day,
            this.itemToEditInterview.hour
          );

          // Add https:// protocol if URL doesn't have it
          if (
            this.itemToEditInterview.urlRedirect &&
            !this.itemToEditInterview.urlRedirect.match(/^https?:\/\//)
          ) {
            this.itemToEditInterview.urlRedirect =
              'https://' + this.itemToEditInterview.urlRedirect;
          }

          this.updating = true;

          const formData = new FormData();
          for (const key in this.itemToEditInterview) {
            if (this.itemToEditInterview.hasOwnProperty(key)) {
              formData.append(key, this.itemToEditInterview[key]);
            }
          }

          InterviewsDataService.update(this.itemToEditInterview.id, formData).then(
            (response) => {
              if (response.status == 204) {
                this.getAllCandidates(1);
                this.expanded = [];
                this.successfullEditInterview = true;
                this.messageEditInterview = 'Videointerview successfully edited.';
                this.editInterviewDialog = false;
                this.$forceUpdate();
              } else {
                this.successfullEditInterview = false;
                this.messageEditInterview =
                  'An error has occurred editing the videointerview. Please, try again later.';
                this.editInterviewDialog = false;
              }

              this.updating = false;
            },
            (error) => {
              this.successfullEditInterview = false;
              this.messageEditInterview =
                'An error has occurred editing the videointerview. Please, try again later.';
              this.editInterviewDialog = false;
              console.error(
                (error.response && error.response.data) || error.message || error.toString()
              );

              if (error.response.status === 401 || error.response.status === 403) {
                localStorage.removeItem('user');
                this.$router.push('/');
              }

              this.updating = false;
            }
          );
        } else {
          this.successfullDialog = false;
          this.messageDialogEditInterview =
            'The date and time specified must be after the current date and time.';
        }
      }
    },
    cancelEditInterview() {
      this.editInterviewDialog = false;
    },
    openShowLinks(interview) {
      this.itemToShowLinks = { ...interview };
      this.showLinksDialog = true;
    },
    async copyToClipboard(text) {
      if (text !== undefined) await navigator.clipboard.writeText(text);
      else await navigator.clipboard.writeText('');
    },
    openUploadCV(candidate) {
      this.uploadCVDialog = true;
      this.itemToUploadCV = { ...candidate };
    },
    uploadCV() {
      // Prevent multiple submissions
      if (this.uploadingCV) {
        console.log('[Upload CV] Already uploading, ignoring duplicate click');
        return;
      }

      this.uploadingCV = true; // Lock the button immediately
      this.successfullUploadCV = true;
      this.messageUploadCV = '';
      this.successfullUploadCVInside = true;
      this.messageUploadCVInside = '';
      const candidates = [];
      const cvs = [];

      for (let i = 0; i < this.fileRecordsForUploadCV.length; i++) {
        candidates.push({
          id: this.itemToUploadCV.id,
          email: this.itemToUploadCV.email,
          fileAssociated: i,
        });
        cvs.push(this.fileRecordsForUploadCV[i].file);
      }

      const formData = new FormData();
      formData.append('candidates', JSON.stringify(candidates));
      cvs.forEach((cv) => {
        formData.append('cvs', cv, cv.name);
      });
      formData.append('candidateId', candidates[0].id);
      if (this.$socketId !== undefined && this.$socketId !== null && this.$socketId !== '')
        formData.append('socketId', this.$socketId);
      else formData.append('socketId', null);

      console.log('[Upload CV] Sending request for candidate:', candidates[0].id);
      CandidatesDataService.upload(formData)
        .then((response) => {
          if (response.status == 202) {
            setTimeout(() => {
              this.getAllCandidates(1);
              this.successfullUploadCV = true;
              this.messageUploadCV = 'CV successfully uploaded.';
              this.uploadCVDialog = false;
              this.$forceUpdate();
            }, 500);
          } else {
            this.successfullUploadCVInside = false;
            this.messageUploadCVInside =
              'An error occurred while uploading CVs. Please try again later.';
          }

          this.fileReceivedCV = false;
          this.fileRecordsCV = [];
          this.fileRecordsForUploadCV = [];
          this.uploadDisactiveCV = true;

          this.uploadingCV = false;
          this.uploadCVDialog = false;
          this.$forceUpdate();
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/home');
          } else {
            this.successfullUploadCVInside = false;
            this.messageUploadCVInside =
              'An error occurred while uploading CVs. Please try again later.';
            this.fileReceivedCV = false;
            this.fileRecordsCV = [];
            this.fileRecordsForUploadCV = [];
            this.uploadDisactiveCV = true;
          }

          this.uploadingCV = false;
          this.uploadCVDialog = false;
          this.$forceUpdate();
        });
    },
    checkStartInterview(interviewDate) {
      const nowTZ = new Date(this.nowTZ);
      interviewDate = new Date(interviewDate);

      interviewDate.setMinutes(interviewDate.getMinutes() - 10);

      return nowTZ.getTime() >= interviewDate.getTime();
    },
    openCV(candidate) {
      this.$router.push({
        name: 'cv info',
        params: { cv: candidate },
      });
    },
    showAnalysis(item) {
      this.$router.push('/interview-analysis/' + item.id);
    },
    canReanalyzeInterview(item) {
      // Enable reanalyze button for all statuses except ONGOING
      // ONGOING: interview is in progress
      return item.status !== 'ONGOING';
    },
    getInterviewAnalysisTypeName(item) {
      const directName = item?.interviewAnalysisType?.name;
      if (typeof directName === 'string' && directName.trim() !== '') return directName;
      const selectedId = Number(item?.interviewAnalysisTypeId);
      if (Number.isFinite(selectedId)) {
        const type = this.analysisTypesEdit.find((t) => Number(t.id) === selectedId);
        if (type?.name) return type.name;
      }
      return '-';
    },
    async openReanalyzeConfirmation(item) {
      if (!Array.isArray(this.analysisTypesEdit) || this.analysisTypesEdit.length === 0) {
        this.loadingReanalyzeAnalysisTypes = true;
        try {
          await this.getAllInterviewAnalysisTypesEdit();
        } finally {
          this.loadingReanalyzeAnalysisTypes = false;
        }
      }
      this.launchAnalysisTargets = [
        {
          id: item.id,
          name: item.name,
          candidateId: item.candidateId,
          analysisTypeId: item?.interviewAnalysisTypeId ?? null,
        },
      ];
      this.launchAnalysisDialog = true;
    },
    onAnalysisLaunched(result) {
      const runIds = (result?.accepted || []).map((entry) => entry.run_id).filter(Boolean);
      if (runIds.length && this.$store?._actions?.['analysisQueue/watchRuns']) {
        this.$store.dispatch('analysisQueue/watchRuns', runIds);
      }
      const candidateId = this.launchAnalysisTargets[0]?.candidateId;
      this.launchAnalysisTargets = [];
      if (candidateId) {
        // Refresh the interviews list once the ledger row exists.
        setTimeout(() => {
          this.getAllInterviewsFromCandidate(candidateId, this.paginationInterviews.page);
        }, 1000);
      }
    },
    checkValidDateTime(dateTime) {
      const stringDateTime = new Date(dateTime);
      const stringNow = new Date(this.now);

      return !(
        stringNow.getTime() === stringDateTime.getTime() ||
        stringNow.getTime() > stringDateTime.getTime()
      );
    },
    getDateTimeTZFormat(date, time) {
      const [year, month, day] = date.split('-').map(Number);
      const [hours, minutes] = time.split(':').map(Number);
      const dateTime = new Date(year, month - 1, day, hours, minutes);

      return dateTime.toISOString();
    },
    getDayHourFromTZ(tzDate) {
      const tzDateSplitted = this.$options.filters.formatDate(tzDate).split(' ');
      return [tzDateSplitted[0], tzDateSplitted[1].substr(0, 5)];
    },
  },
};
</script>

<style scoped>
.create-interview-card {
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.create-interview-form {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 auto;
}

.create-interview-form__body {
  overflow-y: auto;
  min-height: 0;
  padding-bottom: 8px !important;
}
</style>

<style>
.create-interview-dialog-content {
  overflow-y: hidden !important;
}
</style>
